import { FileTextIcon, LoaderCircleIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const CreateResumeFromProfileButton = ({
  isPending = false,
  onClick,
}: {
  isPending?: boolean;
  onClick?: () => void;
}) => {
  /* Render */
  const renderIcon = () => {
    if (isPending) {
      return (
        <LoaderCircleIcon
          className="h-4 w-4 animate-spin text-slate-400"
          strokeWidth={1.5}
        />
      );
    }

    return (
      <FileTextIcon className="h-4 w-4 text-slate-400" strokeWidth={1.5} />
    );
  };

  const render = () => {
    return (
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              className="h-6 w-6"
              disabled={isPending}
              onClick={onClick}
              size="icon"
              type="button"
              variant="ghost"
            >
              {renderIcon()}
            </Button>
          </TooltipTrigger>
          <TooltipContent>Create resume from profile</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  };

  return render();
};
